gsap.registerPlugin(ScrollTrigger);

// Responsive breakpoints
const breakpoints = {
  mobile: 768,
  tablet: 1024,
  desktop: 1200,
};

// Get responsive values based on screen size
function getResponsiveValues() {
  const width = window.innerWidth;

  if (width <= breakpoints.mobile) {
    return {
      backgroundY: 100,
      backgroundScale: 0.9,
      contentY: 50,
      duration: 0.8,
      ease: "power2.out",
    };
  } else if (width <= breakpoints.tablet) {
    return {
      backgroundY: 100,
      backgroundScale: 0.85,
      contentY: 50,
      duration: 0.9,
      ease: "power1.out",
    };
  } else {
    return {
      backgroundY: 100,
      backgroundScale: 0.8,
      contentY: 50,
      duration: 1,
      ease: "power1.out",
    };
  }
}

// Debounce function for resize events
function debounce(func, wait) {
  let timeout;
  return function executedFunction(...args) {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}

// Initialize animations
function initRiseUpAnimations() {
  // Kill existing ScrollTriggers
  ScrollTrigger.getAll().forEach((trigger) => {
    const triggerElement = trigger.vars.trigger;
    if (
      triggerElement instanceof Element &&
      triggerElement.hasAttribute("data-rise-up-section")
    ) {
      trigger.kill();
    }
  });

  document.querySelectorAll("[data-rise-up-section]").forEach((section) => {
    const sectionId = section.dataset.riseUpSection;
    const background = section.querySelector(
      `[data-rise-up-bg="${sectionId}"]`
    );
    const heading = section.querySelector(
      `[data-rise-up-heading="${sectionId}"]`
    );
    const subheading = section.querySelector(
      `[data-rise-up-subheading="${sectionId}"]`
    );
    const subtext = section.querySelector(
      `[data-rise-up-subtext="${sectionId}"]`
    );
    const mockup = section.querySelector(
      `[data-rise-up-mockup="${sectionId}"]`
    );

    if (!background || !heading || !subheading || !subtext || !mockup) return;

    const responsiveValues = getResponsiveValues();

    // Setup initial states
    gsap.set(background, {
      opacity: 0,
      y: responsiveValues.backgroundY,
      scale: responsiveValues.backgroundScale,
    });
    gsap.set([heading, subheading, subtext, mockup], {
      opacity: 0,
      y: responsiveValues.contentY,
    });

    // Create the timeline (paused by default)
    const tl = gsap.timeline({
      paused: true,
      defaults: { ease: responsiveValues.ease, duration: 0.6 },
    });

    // Step 1: Background rise
    tl.to(background, {
      y: 0,
      scale: 1,
      opacity: 1,
      // duration: responsiveValues.duration,
      duration: 1,
      ease: "ease",
    });

    // Step 2: Content fade/slide up
    tl.to(heading, { y: 0, opacity: 1, duration: 0.6, ease: "ease" }, "-=1.2");
    tl.to(mockup, { y: 0, opacity: 1, duration: 2, ease: "ease" }, "-=1.2");
    tl.to(subheading, { y: 0, opacity: 1, duration: 2, ease: "ease" }, "-=2");
    tl.to(subtext, { y: 0, opacity: 1, duration: 0.6, ease: "ease" }, "-=2");

    // ScrollTrigger controls playback - runs once only
    ScrollTrigger.create({
      trigger: section,
      start: "top 60%", // when section reaches top of viewport
      end: "+=100%", // pin for the height of the section (adjust as needed)
      once: true, // Run only once
      onEnter: () => tl.play(),
    });
  });
}

// Initialize on load
document.addEventListener("DOMContentLoaded", initRiseUpAnimations);

// Re-initialize on resize (debounced)
window.addEventListener("resize", debounce(initRiseUpAnimations, 250));
